interface PaginationProps {
  page: number;
  pageSize: number;
  total: number;
  onPage: (page: number) => void;
}

// Server-side pagination control. Renders "Showing X–Y of T" plus prev/next.
export function Pagination({ page, pageSize, total, onPage }: PaginationProps) {
  if (total <= 0) return null;
  const lastPage = Math.max(1, Math.ceil(total / pageSize));
  const start = (page - 1) * pageSize + 1;
  const end = Math.min(total, page * pageSize);

  return (
    <nav className="pagination" aria-label="Pagination">
      <span className="pagination-info">
        Showing {start.toLocaleString()}–{end.toLocaleString()} of {total.toLocaleString()}
      </span>
      <div className="pagination-controls">
        <button type="button" className="pagination-btn" disabled={page <= 1} onClick={() => onPage(page - 1)}>
          ← Prev
        </button>
        <span className="pagination-page">
          Page {page} of {lastPage}
        </span>
        <button
          type="button"
          className="pagination-btn"
          disabled={page >= lastPage}
          onClick={() => onPage(page + 1)}
        >
          Next →
        </button>
      </div>
    </nav>
  );
}
